import { useTranslation } from 'react-i18next'

import backgroundMain from '@/assets/background/background-main.jpg'
import campaignLogo from '@/assets/logos/campaign-logo.png'

import styles from './LoadingSpinner.module.css'

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large'
  text?: string
  fullscreen?: boolean
}

function SpinnerBars({ className }: { className?: string }) {
  return (
    <div className={`${styles.spinner}${className ? ` ${className}` : ''}`}>
      {Array.from({ length: 8 }, (_, index) => (
        <div
          key={index}
          className={styles.spinnerBar}
          style={{ '--i': index } as React.CSSProperties}
        >
          <div className={styles.spinnerBarInner} />
        </div>
      ))}
    </div>
  )
}

export function LoadingSpinner({
  size = 'large',
  text = '',
  fullscreen = false,
}: LoadingSpinnerProps) {
  const { t } = useTranslation()

  if (fullscreen) {
    return (
      <div
        className={styles.fullscreen}
        style={{ backgroundImage: `url(${backgroundMain})` }}
      >
        <img src={campaignLogo} alt="" className={styles.logo} />
        <div className={styles.card}>
          <SpinnerBars />
          <span className={styles.cardText}>{t('loading-spinner.label')}</span>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <SpinnerBars className={styles[size]} />
      {text && <div className={styles.text}>{text}</div>}
    </div>
  )
}
